
export default {
  name: 'GcDropShadow',
  data() {
    return {
      className: 'gc__drop-shadow',
    };
  },
  computed: {
    disableHoverClassName() {
      return this.disableHover ? `${this.className}__disable-hover` : '';
    },
  },
  props: {
    disableHover: {
      type: Boolean,
      default: false,
    },
    styleObject: {
      type: Object,
      default: null,
    },
  },
  methods: {

  },
};
